import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const FieldBox = styled(Box)`
  border: 1px solid gray;
  margin: 10px 0;
  border-radius: 7px;
  padding: 10px 5px;
`;
